jQuery(document).ready(function ($) {
  $mst_target = $('#scroll-top');

  // Scroll-Top
  $mst_target.click(function(){
    scrollTop();
  });

  var scrollTop = function () {
    var $page = $('html, body');

    $page.on('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove', function () {
      $page.stop();
    });

    $page.animate({
      scrollTop: 0,
    }, 1000, function () {
        $page.off('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove');
      });

    return false;
  };

  // Fade-in
  $init_window_height = $(window).height();

  $(window).scroll(function(){
    scrollIndicator();

    if($init_window_height < $(document).scrollTop()){
      if(!$mst_target.hasClass('is-visible')){
        $mst_target.addClass('is-visible');
      }
    } else {
      if($mst_target.hasClass('is-visible')){
        $mst_target.removeClass('is-visible');
      }
    }
  });

  function scrollIndicator() {
    var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
    var length = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    var scrolled = (winScroll / length) * 100;
    var circle = 308 - (308 / 100 * scrolled);
    document.getElementById("scroll-top__indicator").style.strokeDashoffset = circle;
  }

});